export const TOAST_MARGIN_LEFT = 100;

export const TOOLBAR_COMPONENT_HEIGHT = 8;

export const SIDE_PANEL_COLOR_PICKER_HEIGHT = '326px';

export const TAB_PANEL_MIN_HEIGHT = 430;

export const UNDO_BUTTON_ID = 'editor-navbar-undo';
export const REDO_BUTTON_ID = 'editor-navbar-redo';
export const NAVBAR_HEIGHT = 60;
export const CHATBOT_WIDGET_ICON_HEIGHT = 72;
export const CHATBOT_WIDTH = 128;
// Set the radius for the proximity circle around the mouse cursor
export const PROXIMITY_RADIUS = 20; // This is the distance from the cursor to the edge of the detection circle
export const MAX_TEXT_GENERATION_CREDITS = 6;
